import { factory } from 'typescript';

export class Lazy<T> {
  private _value: T;

  constructor(public readonly factory: () => T) {
  }

  get value() {
    if (this._value === undefined) {
      this._value = this.factory();
    }

    return this._value;
  }
};

export function lazy<T>(factory: () => T) {
  return new Lazy<T>(factory);
}

export function lazyConcat<T>(lists: T[][], callback?: (items: T[]) => T[]): Lazy<T[]>;
export function lazyConcat<T>(getLists: () => T[][], callback?: (items: T[]) => T[]): Lazy<T[]>;
export function lazyConcat<T>(listsOrFn: T[][] | (() => T[][]), callback?: (items: T[]) => T[]): Lazy<T[]> {
  return lazy(() => {
    let lists = (typeof listsOrFn === 'function') ? listsOrFn() : listsOrFn;
    
    let totalCount = lists.reduce((n, l) => n + l.length, 0);

    let items: T[] = [];

    items.length = totalCount;

    let n = 0;

    for (let list of lists) {
      for (let item of list)
        items[n++] = item;
    }

    if (callback)
      items = callback(items);

    return items;
  });
}
